export const arr3eq = (a, b, eps = 1e-7) => {
    const aa = Array.isArray(a) ? a : [0, 0, 0]
    const bb = Array.isArray(b) ? b : [0, 0, 0]
    return [0, 1, 2].every((i) => Math.abs((Number(aa[i]) || 0) - (Number(bb[i]) || 0)) <= eps)
}